import { CORE_BASIC_SERVICE_URI, CORE_SEARCH_SERVICE_URI, LAB_SERVICE_URI, ACCOUNT_SERVICE_URI, EUREKA_SERVICE_URI, WORKSPACE_SERVICE_URI } from './config';

let _coreTelecomApiUrlPrefix = `${CORE_SEARCH_SERVICE_URI}/core-telecom-api/telecom`;
export const coreBasicApiUrlPrefix = `${CORE_BASIC_SERVICE_URI}/core-basic-api`;
const useLocalApi = false;
// 产线环境编译时会去掉
if (import.meta.env.DEV) {
    if (useLocalApi) {
        _coreTelecomApiUrlPrefix = 'http://127.0.0.1:8080/telecom';
    }
}
export const coreTelecomApiUrlPrefix = _coreTelecomApiUrlPrefix;

let _noveltyAiSearchApiUrlPrefix = `${CORE_SEARCH_SERVICE_URI}/novelty-search/v2/novelty`;
if (import.meta.env.DEV) {
    if (useLocalApi) {
        _noveltyAiSearchApiUrlPrefix = 'http://127.0.0.1:8000/v2/novelty';
    }
}
export const noveltyAiSearchApiUrlPrefix = _noveltyAiSearchApiUrlPrefix;
export const designFtoApiUrlPrefix = `${CORE_SEARCH_SERVICE_URI}/fto-image-api/fto-image`;
export const ftoProApiUrlPrefix = `${EUREKA_SERVICE_URI}/ai-patent-agent/fto_pro`;
export const eurekaApiUrlPrefix = `${EUREKA_SERVICE_URI}/eureka`;
export const agentApiUrlPrefix = `${EUREKA_SERVICE_URI}/ai-agent-api`;
export const coreSearchApiUrlPrefix = `${CORE_SEARCH_SERVICE_URI}/core-search-api/search`;
export const labServiceApiUrlPrefix = `${LAB_SERVICE_URI}/lab-service`;
export const accountServiceApiUrlPrefix = `${ACCOUNT_SERVICE_URI}/user-service`;
export const workspaceServiceApiUrlPrefix = `${WORKSPACE_SERVICE_URI}/workspace`;
